export default "__VITE_ASSET__C7mq4f7A__"